import React, { FC, ReactNode, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { ChevronDownIcon } from '../../../../assets/icons/index';
import { Tooltip } from '../../../../components/tooltip/index';

export type EventDocumentsAccordionProps = {
  children: ReactNode;
  /** Files already in the bucket, badged beside the title so a collapsed bucket still shows them. */
  fileCount?: number;
  isOpenOnStart?: boolean;
  title: string;
};

export const EventDocumentsAccordion: FC<EventDocumentsAccordionProps> = ({
  children,
  fileCount = 0,
  isOpenOnStart = false,
  title,
}) => {
  const [isOpen, setIsOpen] = useState(isOpenOnStart);
  const [hasBeenOpened, setHasBeenOpened] = useState(isOpenOnStart);

  const handleToggle = () => {
    setIsOpen((open) => !open);
    setHasBeenOpened(true);
  };

  return (
    <div className="flex w-full flex-col">
      <button
        className={twMerge(
          'flex h-11 w-full shrink-0 items-center justify-between bg-gray-50 p-4 transition-[border-radius] duration-200',
          isOpen ? 'rounded-t-md' : 'rounded-md',
        )}
        onClick={handleToggle}
        type="button"
      >
        <div className="flex min-w-0 items-center gap-2">
          <Tooltip childrenWrapperClassName="max-w-[350px]" content={title}>
            <span className="truncate text-sm font-[450] text-gray-700">{title}</span>
          </Tooltip>
          {fileCount > 0 && (
            <span className="shrink-0 rounded-full bg-brand-100 px-2 py-0.5 text-xs font-[550] text-brand-700">
              {fileCount}
            </span>
          )}
        </div>
        <ChevronDownIcon
          className={twMerge('size-4 transition-transform duration-200', isOpen && 'rotate-180')}
          iconColor="#344054"
        />
      </button>

      <div
        className={twMerge(
          'grid grid-flow-row transition-all duration-200 ease-in-out',
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        )}
      >
        <div className="overflow-hidden">
          {hasBeenOpened && (
            <div className="flex w-full flex-col gap-3 rounded-b-lg border border-gray-100 px-4 pb-3 pt-4">
              {children}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
